import React, { Fragment, useState, useEffect } from 'react';

import icons from './../../../icons.svg';
import MultipleProdutsSlots from '../modals/MultipleProductsSlots';

const ScaleHybridCabinetPlanogram = ({
  cabinetActions,
  planogramData,
  allProducts = [],
  t,
  cabinet,
  slotSelected,
}) => {
  const [openSlotInfoOverlay, setOpenSlotInfoOverlay] = useState({
    open: false,
    slotData: {},
    shelfNumber: null,
  });

  useEffect(() => {
    if (cabinetActions && cabinetActions.handleFetchCabinetInventory)
      cabinetActions.handleFetchCabinetInventory(cabinet.deviceCode);
  }, []);

  /**
   * handle slot selection differently depending upon calibration status
   * @param {*} shelf shelf selected
   * @param {*} slot slot selected
   * @param {*} product selected product
   */
  const handleSlotClickInPlanogram = (
    shelfNumber,
    selectedSlotData,
    product
  ) => {
    if (cabinet.calibration === 'on' && isScaleShelf(shelfNumber)) {
      slotSelected({
        shelfNumber: shelfNumber,
        slotData: selectedSlotData,
        product,
      });
    } else {
      setOpenSlotInfoOverlay({
        open: true,
        slotData: selectedSlotData,
        shelfNumber,
      });
    }
  };

  /**
   * check if the shelf number is a scale shelf
   * @param {*} shelfNumber
   * @returns
   */
  const isScaleShelf = shelfNumber =>
    planogramData.shelves.find(
      shelf => shelf.type === 'scale1' && shelf.shelf === shelfNumber
    );

  return (
    <Fragment>
      <MultipleProdutsSlots
        isOpen={openSlotInfoOverlay.open}
        close={() =>
          setOpenSlotInfoOverlay({
            open: false,
            slotData: {},
            shelfNumber: null,
          })
        }
        cabinetActions={cabinetActions}
        cabinetSlotData={openSlotInfoOverlay.slotData}
        shelfNumber={openSlotInfoOverlay.shelfNumber}
        allProducts={allProducts}
        t={t}
        cabinet={cabinet}
        scaleShelves={
          planogramData.shelves.filter(shelf => shelf.type === 'scale1') || []
        }
      />
      <div className="planogram__cabinet">
        <div className="planogram__cabinet-shelves">
          {(() => {
            const allShelves = [];
            // for each shelf data, draw slot in the planogram
            planogramData.shelves.forEach(shelf => {
              allShelves.push(
                <div
                  className={`planogram__cabinet-shelf ${
                    shelf.type === 'rfid'
                      ? 'planogram__cabinet-shelf--rfid'
                      : ''
                  }`}
                  key={`shelf-${shelf.shelf}`}
                >
                  <div className="planogram__slots">
                    {(() => {
                      // loop throgh all the slots in the particular shelf
                      const allSlots = [];
                      shelf.slots &&
                        shelf.slots.forEach(slot => {
                          //the product assinged to the slot during calibration
                          const assignedProductId = slot.productId;

                          //the product planned in the planogram
                          const planogramProductId =
                            slot.products && Array.isArray(slot.products)
                              ? slot.products[0]
                              : null;

                          const selectedAssignedProduct = allProducts.find(
                            product => product.id === assignedProductId
                          );

                          const selectedPlanogramProduct = allProducts.find(
                            product => product.id === planogramProductId
                          );
                          // display product from planogram first, and if not, display assinged product. otherwise just display a scale icon
                          const productToRender = selectedPlanogramProduct
                            ? selectedPlanogramProduct
                            : selectedAssignedProduct
                            ? selectedAssignedProduct
                            : null;

                          //if slot has no product assined or planned, just show the scale icon
                          if (!productToRender) {
                            allSlots.push(
                              <div
                                className="planogram__slots-item"
                                key={`shelf-${slot.slot}`}
                                onClick={() =>
                                  handleSlotClickInPlanogram(shelf.shelf, {
                                    slot: slot.slot,
                                    productAssigned: '',
                                    products: [],
                                  })
                                }
                              >
                                <svg className="planogram__slots-item-cube">
                                  <use
                                    xlinkHref={`${icons}#icon-balance-scale`}
                                  ></use>
                                </svg>
                              </div>
                            );
                          }

                          // compare two different products
                          // are the planogram product and product calibrated same for the slot?
                          const sameProduct =
                            selectedAssignedProduct?.id ===
                            selectedPlanogramProduct?.id;

                          if (productToRender) {
                            allSlots.push(
                              <div
                                className={`planogram__slots-item`}
                                key={`slot-${shelf.shelf}-${slot.slot}-${productToRender.id}`}
                                onClick={() =>
                                  handleSlotClickInPlanogram(
                                    shelf.shelf,
                                    {
                                      slot: slot.slot,
                                      products: planogramProductId
                                        ? [planogramProductId]
                                        : [],
                                      productAssigned: assignedProductId,
                                    },
                                    assignedProductId
                                  )
                                }
                              >
                                {productToRender.imageUrl ? (
                                  <img
                                    src={productToRender.imageUrl}
                                    alt="product"
                                  />
                                ) : (
                                  <svg className="planogram__slots-item-cube">
                                    <use xlinkHref={`${icons}#icon-cube`}></use>
                                  </svg>
                                )}

                                {selectedPlanogramProduct &&
                                  !selectedAssignedProduct &&
                                  shelf.type === 'scale1' && (
                                    <svg className="planogram__slots-item-cube planogram__slots-item-cube--overlay">
                                      <use
                                        xlinkHref={`${icons}#icon-balance-scale`}
                                      ></use>
                                    </svg>
                                  )}

                                {((!selectedPlanogramProduct &&
                                  selectedAssignedProduct &&
                                  shelf.type === 'scale1') ||
                                  !sameProduct) && (
                                  <svg className="planogram__slots-item-cube planogram__slots-item-cube--overlay planogram__slots-item-cube--warn">
                                    <use
                                      xlinkHref={`${icons}#icon-warning`}
                                    ></use>
                                  </svg>
                                )}
                              </div>
                            );
                          }
                        });
                      return allSlots;
                    })()}
                  </div>
                </div>
              );
            });
            return allShelves;
          })()}
        </div>
      </div>
    </Fragment>
  );
};

export default ScaleHybridCabinetPlanogram;
